import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { deconstructDateString } from '../../../../../../../core/util/date';
import {
  scanCompletedBack,
  scanCompletedFront,
  setCardIdBack,
  setCardIdFront,
  setOcrDataFront,
} from '../../../../../../../actions/addInsurance';
import { setRuntimeVariable } from '../../../../../../../actions/runtime';
import useSelectInsuranceProfile from '../../../../../hooks/useSelectInsuranceProfile';

export default (userProfileId: any) => {
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const dispatch = useDispatch();

  return useCallback(() => {
    const { day, month, year } = deconstructDateString(insuranceProfile.birth_date);
    dispatch(
      setOcrDataFront({
        firstName: insuranceProfile.first_name,
        lastName: insuranceProfile.last_name,
        insuranceCarrier: insuranceProfile.insurer_name,
        insuranceType: insuranceProfile.insurer_type,
        memberId: insuranceProfile.member_code,
        dobDay: day,
        dobMonth: month,
        dobYear: year,
      })
    );
    dispatch(setCardIdFront(insuranceProfile.card_front_id));
    dispatch(setCardIdBack(insuranceProfile.card_back_id));
    dispatch(scanCompletedFront());
    dispatch(scanCompletedBack());
    dispatch(setRuntimeVariable({ name: 'isEditFlow', value: true }));
  }, [
    dispatch,
    insuranceProfile.birth_date,
    insuranceProfile.card_back_id,
    insuranceProfile.card_front_id,
    insuranceProfile.first_name,
    insuranceProfile.insurer_name,
    insuranceProfile.insurer_type,
    insuranceProfile.last_name,
    insuranceProfile.member_code,
  ]);
};
